import { axiosInstance } from "apis/_axios";

export const userLogin = (data) => axiosInstance().post("/login", data);

export const userLogout = () => axiosInstance().post("/logout");

export const userRegister = (data) =>
  axiosInstance().post("/account-verification", data);
